export * from './crm-vehicle-insurance-find.endpoint';
export * from './crm-vehicle-insurance-create.endpoint';
export * from './crm-vehicle-insurance-patch.endpoint';
export * from './crm-vehicle-insurance-delete.endpoint';
export * from './crm-vehicle-insurance-get-by-id.endpoint';
